import React, { useEffect, useState, Fragment } from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Magnify from "mdi-material-ui/Magnify";
import ChevronRight from "mdi-material-ui/ChevronRight";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import { LessonInfo } from "../../../../layouts/components/coursePlayer/PlayList/helper";

const LessonSearch = ({ lessons, activeLessonHandler, isMobile, controlSx = {} }) => {
  const [searchModal, setSearchModal] = useState({ visible: false });
  const [filteredLessons, setFilteredLessons] = useState(lessons);

  useEffect(() => {
    if (!searchModal.visible) {
      setFilteredLessons(null);
    } else {
      setFilteredLessons(lessons);
    }
  }, [searchModal]);

  return (
    <Fragment>
      <Tooltip title="Pesquisar aula">
        <IconButton aria-label="Pesquisar aula" sx={controlSx} onClick={() => setSearchModal({ visible: true })}>
          <Magnify />
        </IconButton>
      </Tooltip>
      <Dialog
        style={{ zIndex: 99999 }}
        fullWidth={isMobile ? true : false}
        open={searchModal.visible}
        onClose={() => setSearchModal({ visible: false })}
        aria-labelledby="lesson-search-title"
        PaperProps={{ className: "sp-modal__paper" }}
      >
        <DialogContent className="sp-modal sp-modal--left sp-modal--search">
          <div className="sp-modal__head">
            <span className="sp-modal__icon">
              <Magnify />
            </span>
            <h2 id="lesson-search-title" className="sp-modal__title">
              Pesquisar aula
            </h2>
          </div>

          <div className="sp-modal__search">
            <Magnify />
            <input
              className="sp-modal__search-input"
              type="text"
              autoFocus
              placeholder="Procurar..."
              onChange={(e) => {
                const searchTerm = e.target.value.toLowerCase();

                // Search lessons by title and content
                const results = lessons.filter(
                  (lesson) => lesson?.title?.toLowerCase().includes(searchTerm) || lesson?.content?.toLowerCase().includes(searchTerm)
                );

                setFilteredLessons(results);
              }}
            />
          </div>

          <div className="sp-modal__list">
            {filteredLessons?.length === 0 && <div className="sp-modal__empty">Nenhum resultado encontrado</div>}
            {filteredLessons?.map((lesson) => (
              <button
                type="button"
                key={lesson.lesson_id}
                className="sp-modal__row"
                onClick={() => {
                  activeLessonHandler(lesson.chapter_id, lesson.lesson_id);
                  setSearchModal({ visible: false });
                }}
              >
                <LessonInfo lesson={lesson} />
                <span className="sp-modal__row-title">{lesson.title}</span>
                <span className="sp-modal__go">
                  Ir para a aula
                  <ChevronRight />
                </span>
              </button>
            ))}
          </div>
        </DialogContent>
        <DialogActions className="sp-modal__actions">
          <button type="button" className="sp-modal__btn sp-modal__btn--primary" onClick={() => setSearchModal({ visible: false })}>
            Fechar
          </button>
        </DialogActions>
      </Dialog>
    </Fragment>
  );
};

export default LessonSearch;
